export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FETCH_PRICES = 'FETCH_PRICES';
export const GET_BALANCES = 'GET_BALANCES';
export const RELOAD_DATA_TABLE = 'RELOAD_DATA_TABLE';
